import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
export const useResponsiveness = () => {
    const theme = useTheme();
    const isExtraSmallViewport = useMediaQuery(theme.breakpoints.down('sm'));
    const isLargeViewport = useMediaQuery(theme.breakpoints.up('md'));
    return { isExtraSmallViewport, isLargeViewport };
};
